import createCrudModule from '@/utils/createCrudModule'

export default createCrudModule({
  resource: 'influencerCategories',
  urlRoot: '/influencer_categories'
})
